import * as React from 'react'
import './index.css'

const LEFT = 0
const RIGHT = 1

interface IState {
  showDialog: boolean
}

interface Props {
  title?: string
  message?: string
  leftBtnText?: string
  rightBtnText?: string
  onClickLeftBtn?: () => void
  onClickRightBtn?: () => void
  onClickMask?: () => void
  notModal?: boolean // 是否在modal中展示
}

export default class CommonDialog extends React.Component<Props, IState> {
  constructor (props: Props) {
    super(props)
    this.state = {
      showDialog: true,
    }
  }

  onClickBtn = (btn: number) => {
    if (btn === LEFT) {
      this.props.onClickLeftBtn?.()
    } else if (btn === RIGHT) {
      this.props.onClickRightBtn?.()
    }
  }

  onCloseDialog = () => {
    if (this.props.onClickMask) {
      this.props.onClickMask?.()
    } else {
      this.props.onClickLeftBtn?.()
    }
  }

  renderContainer = () => {
    const { title, message } = this.props
    return (
      <view className="dialog-mask">
        <view
          className="dialog-container"
          onClick={() => {
            // do noting 防止点击内容区域弹窗消失
          }}
        >
          <view className="dialog-content">
            {title ? <text className="dialog-title" content={title} /> : null}
            {message ? <text className="dialog-message" content={message} /> : null}
          </view>
          <view className="dialog-button-container">
            {this.props.leftBtnText && <text style={{ border: '1px solid #808080' }} className="dialog-button" content={this.props.leftBtnText} onClick={() => this.onClickBtn(LEFT)} />}
            {this.props.leftBtnText && this.props.rightBtnText ? <view className="gap" /> : null}
            {this.props.rightBtnText && <text className="dialog-button dialog-button-right" content={this.props.rightBtnText} onClick={() => this.onClickBtn(RIGHT)} />}
          </view>
        </view>
      </view>
    )
  }

  render () {
    const { notModal } = this.props
    if (notModal) {
      return this.renderContainer()
    }

    return <modal onRequestCloseDialog={() => this.onCloseDialog()}>{this.renderContainer()}</modal>
  }
}
